import {
  BadgeCheckIcon,
  DiamondIcon,
  RocketIcon,
  StarIcon,
  TrophyIcon,
} from "lucide-react";

import { IconData } from "simplydo/react/ui/icon";

export const ROLE_ICONS = {
  star: StarIcon,
  rocket: RocketIcon,
  trophy: TrophyIcon,
  "badge-check": BadgeCheckIcon,
  diamond: DiamondIcon,
} as const satisfies Record<string, IconData>;

export type RoleIconName = keyof typeof ROLE_ICONS;

export const ROLE_ICON_NAMES = Object.keys(ROLE_ICONS) as RoleIconName[];

export function isRoleIconName(name: string): name is RoleIconName {
  return name in ROLE_ICONS;
}

export function getRoleIcon(name?: string | null): IconData | undefined {
  if (!name || !isRoleIconName(name)) return undefined;
  return ROLE_ICONS[name];
}
